export default __webpack_public_path__ + "static/media/Inter-LightItalic.c0c6857d.woff2";